import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class ShortcutService {
	shortcutMap = new Map<string, () => void>()
	shortcuts: Array<{ text: string; shortcut: string; displayedShortcut: string }> = []
}
